"use strict";

function isFuture(value) {
    if (!value) {
        return;
    }
    var parts = value.split(/\D/, 2);
    if (!(parts[0] && parts[0].length == 2 && parts[1] && parts[1].length == 2)) {
        return;
    }
    var date = new Date(2000 - -parts[1], parts[0] - 1, 1);
    return (date.getTime() > Date.now());
}
export const settings = {
    options: {
        message: "Expires in the past"
    }
};

export default function expirey(options) {
    const opts = options ? {...settings.options, options} : settings.options;
    return function expirey$return(val) {
        if (val && !isFuture(val)) {
            return {
                message: opts.message,
                level: opts.level,
                type: opts.type
            }
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/validators/expirey.js
 **/